var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"spinner-grow text-danger",attrs:{"role":"status"}}),_c('p',{staticClass:"mb-0 mt-2 text-light"},[_vm._v(_vm._s(_vm.text || "Loading..."))])])}
var staticRenderFns = []

export { render, staticRenderFns }